<template>
    <div id="login">
        <div class="login-content">
            <h2>P2P</h2>
            <div class="login">
                <el-row>
                    <el-col style="margin-top: 30px;color: #000;text-align:center;font-size: 20px;">管理员登录</el-col>
                </el-row>
                <div class="login-form">
                    <el-form ref="form" :model="form" :rules="rules">
                        <el-form-item prop="username">
                            <el-input v-model="form.username" placeholder="请输入账号" @keyup.enter.native="onSubmit">
                                <i slot="prefix" class="img">
                                    <img src="@/assets/img/login/user.png" />
                                </i>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input type="password" v-model="form.password" placeholder="请输入密码" @keyup.enter.native="onSubmit" show-password>
                                <i slot="prefix" class="img">
                                    <img src="@/assets/img/login/password.png" />
                                </i>
                            </el-input>
                        </el-form-item>
                        <el-row :gutter="4" class="codeMessage">
                            <el-col :span="6">
                                <el-select placeholder="请选择" size="mini" v-model="form.phone">
                                    <el-option label="刘总" value="1"></el-option>
                                    <el-option label="陈总" value="2"></el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="10">
                                <el-form-item prop="code" style="margin-bottom: 12px;">
                                    <el-input type="text" v-model="form.code" placeholder="请输入验证码" @keyup.enter.native="onSubmit"></el-input>
                                    <el-col v-if="disabled" style="position:absolute;top: 50px;left:0;text-align:left;color: #f00;font-size: 12px;">验证码超时，请重新获取</el-col>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8" style="text-align:right;">
                                <el-form-item>
                                    <el-button size="medium" v-show="show" @click="sendMessageHandle">发送验证码</el-button>
                                    <el-button v-show="!show" size="medium">{{count}} s</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <!--<el-form-item prop="code" style="margin-bottom: 12px;">
                            <el-row :gutter="6">
                                <el-col :span="6">
                                    <el-select placeholder="请选择" size="mini">
                                        <el-option label="陈总" value="1"></el-option>
                                        <el-option label="刘总" value="2"></el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="10">
                                    <el-input type="text" v-model="form.code" placeholder="请输入验证码" @keyup.enter.native="onSubmit"></el-input>
                                    <el-col v-if="disabled" style="position:absolute;top: 50px;left:0;text-align:left;color: #f00;font-size: 12px;">验证码超时，请重新获取</el-col>
                                </el-col>
                                <el-col :span="8" style="text-align:right;">
                                    <el-button size="medium" v-show="show" @click="sendMessageHandle">发送验证码</el-button>
                                    <el-button v-show="!show" size="medium">{{count}} s</el-button>
                                </el-col>
                            </el-row>
                        </el-form-item>-->
                        <el-row>
                            <el-col class="forgetPass">
                                <router-link to="/login">
                                    普通用户登录
                                </router-link>
                            </el-col>
                        </el-row>
                        <el-form-item class="login-btn">
                            <el-button type="primary" @click="onSubmit" :disabled="disabled" :loading="loginLoading">登录</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <div class="login-footer">
            <div>
                    <p>
                        <span style="margin-right: 40px;"><a target="_blank" href="https://beian.miit.gov.cn/">豫ICP备2021031026号-2</a></span>
                        <img src="@/assets/img/police_icon.png" style="height: 15px;margin-right: 4px;"/>
                        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41010502005246">豫公网安备 41010502005246号</a>
                    </p>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex';
import crypto from 'crypto' 
export default {
    name: 'login',
    data() {
        return {
            disabled: false,
            show: true,
            count: '',
            timer: null,
            loginLoading:false,
            form: {
                username: '',
                password: '',
                phone: '1',
                code: ''
            },
            rules:{
                username:[
                    {required:true,message:"请输入用户名",trigger:"blur"}
                ],
                password:[
                    {required:true,message:"请输入密码",trigger:"blur"},
                    // {min:3,max:10,message:"密码长度为3-10位",trigger:"blur"},
                ],
                code: [
                    {required:true,message:"请输入验证码",trigger:"blur"}
                ]
            }
        }
    },
    methods: {
        /*登录*/
        ...mapMutations(['changeLogin']),
        getCode(){
            const TIME_COUNT = 60;
            this.disabled = false;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                    } else {
                        this.show = true;
                        clearInterval(this.timer);
                        this.timer = null;
                        this.disabled = true;
                        this.form.code = '';
                        this.$message.info('验证码超时，请重新获取');
                    }
                }, 1000)
            }
        },
        sendMessageHandle() {
            const self = this
            const formData = new FormData()
            formData.append('account', self.form.username)
            //self.getCode();
            self.axios.get(self.GLOBAL.IP+"/common/sendCode?account="+self.form.username+"&phone="+self.form.phone)
            .then(res => {
                if(res.data.code == 200) {
                    self.getCode();
                } else {
                    self.$message.info(res.data.msg)
                }
            }).catch(err => {
                self.$message.error('短信发送失败！')
            })
        },
        onSubmit(){
            let _that = this
            if(this.show) {
                this.$message.info('请获取验证码');
                return false
            }
            _that.$refs.form.validate((valid)=>{
                if(valid){
                    _that.loginLoading = true
                    const data = {
                        account:_that.form.username,
                        password: _that.getmd5( _that.form.password ),
                        code: _that.form.code,
                        
                    }
                    //判断复选框是否被勾选 勾选则调用配置cookie方法
                    _that.$api.post(_that.GLOBAL.IP+"/user/login",data).then(function(res){
                        if(res.code == 200){
                            const Data = res.data;
                            localStorage.setItem('userInfo', JSON.stringify(Data));
                            _that.changeLogin({Authorization: Data.token});
                            _that.$store.dispatch('setUserInfo', Data);
                            _that.$api.get(_that.GLOBAL.IP + '/naviGat/getMenu')
                            .then(res => {
                                _that.loginLoading = false
                                if(res.data && res.data.length > 0) {
                                    var url = res.data[0].LowerLevel?res.data[0].LowerLevel[0].url:res.data[0].url;
                                    _that.$router.push(url);
                                    //  去掉60s
                                    _that.show = true;
                                    clearInterval(_that.timer);
                                    _that.timer = null;
                                } else {
                                    _that.$message.info('该账户无权限')
                                }
                            })
                            .catch(err => {
                                _that.loginLoading = false
                                // _that.$message.error('导航栏获取失败');
                            })
                            
                        }else{
                            _that.loginLoading = false
                            _that.$message.error(res.msg || res.error);
                        }
                    }).catch(function(err){
                        _that.loginLoading = false
                        _that.$message({
                            message: '登录失败',
                            type: 'error'
                        });
                    });
                }else{
                    return false;
                }
            })
        },
        getmd5(pwd){
            var md5 = crypto.createHash("md5");
            md5.update(pwd);
            var password = md5.digest('hex');
            return password;
        },
    }
}
</script>

<style lang="scss" scoped>
    @import '@/assets/css/vars.scss';
    h2 {
        font-size: 42px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #FFFFFF;
        margin: 0 0 80px 0;
    }
    #login {
        width: 100%;
        height: 100%;
        background-image: linear-gradient(#2b3849,#cbcad0);
        //background: url('../assets/img/login/background.png') no-repeat;
        //background-size: 100% 100%;
        display:flex;
        align-items:center;
        justify-content:center;
    }
    .login-content {
        width: 446px;
        color: #fff;
    }
    .login {
        height: 390px;
        background: #FFFFFF;
        border-radius: 16px;
    }
    .login-form {
        padding: 40px 40px 10px 40px;
    }
    .login-form .el-form-item {
        margin-bottom: 20px;
    }
    .login-form .el-form-item.item {
        margin-bottom: 40px;
    }
    .login-form .login-btn {
        margin-top: 0px;
    }
    .login-form /deep/ .el-input__inner,
    .login-form >>> .el-input__inner,
    .login-form .el-input__inner {
        border: 1px solid #CCCCCC;
        border-radius: 6px;
        background:#fff;
        color: #333333;
        text-align: left;
        height: 44px;
        padding-left: 60px;
    }
    .login-form /deep/ .el-button--primary,
    .login-form >>> .el-button--primary,
    .login-form .el-button--primary {
        width: 100%;
        height: 45px;
        margin-top: 18px;
        background: $main-Defaultcolor;
        border-radius: 6px;
        color: #fff;
        font-size: 16px;
        border: none;
    }
    .login-form .el-form-item i.img {
        display: inline-block;
        padding: 1px 0 0 20px;
    }
    .login-footer {
		position:fixed;
		bottom:0;
		width: 100%;
		text-align:center;
		color:#65b8ff;
		padding-top: 10px;
	}
	.login-footer p {
		color: #fff;
		font-size: 14px;
        margin: 10px 0;
        height: 20px;
        line-height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
	}
    .forgetPass {
        text-align: right;
        color: #666;
        font-size: 14px;
        cursor: pointer;
    }
    .forgetPass a {
        color: #666;
    }
    .codeMessage /deep/ .el-input__inner,
    .codeMessage >>> .el-input__inner {
        padding-left: 20px;
    }
    .login-footer p a {
        color: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/views/loginAdmin.vue